import React from 'react';

const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-accent-sand">
      <div className="text-center">
        <div className="inline-block w-16 h-16 border-4 border-secondary-500 border-t-transparent rounded-full animate-spin mb-4"></div>
        <h2 className="text-xl font-semibold text-text-heading">Loading...</h2>
        <p className="text-text-description">Please wait while we set things up</p>
      </div>
    </div>
  );
};

export default LoadingScreen; 